import { IGrupoEvento } from "../interfaces/IGrupoEvento";
import api from "./Api";

class GrupoEventoService {
    async obterTodos() :Promise<IGrupoEvento[]> {
        try {
            const { data: result } = await api.get<IGrupoEvento[]>('GrupoEvento');
            
            return result;
        } catch (error) {	
            return [];
        }
    }
}

export default new GrupoEventoService();